import { Roles } from './role-model';

export class User {
    id?: number;
    loginId?: string;
    firstName?: string;
    lastName?: string;
    middleName?: string;
    userName?: string; // For internal user
    approvalStatus?: string;
    lastLoginTime?: string;
    type?: string;
    rejectionReason?: string;
    email?: string; // used in FSC
    userInternalOrExternal?: string;
    uuidCookie?: string;
    emailAddress?: string;  // used in FCL
    phone?: string;
    company?: string;
    address1?: string;
    address2?: string;
    city?: string;
    state?: string;
    postalCode?: string;
    countryCode?: string;
    userCustomers?: UserCustomers[] = [];
    userRolesList?: UserRoles[] = [];
    requestIdentifier?: string;
    transactionDate?: string;
    createdDate?: string;
    createdBy?: string;
    updatedDate?: string;
    updatedBy?: string;
    success?: boolean;
    errors?: Error[] = [];
    fclContactname?: string;
    fdxLogin?: string;
    fclFname?: string;
    fclUuid?: string;
    fclAuthToken?: string;
    jwtToken?: string;
    preferredUsername?: string;
    fedExId?: string;
    okTempUserId?: string;
    locale?: string;
    selectedUser?:string;
}

export class UserStatus {
    trans_uuid?: string;
    users?: Users[] = [];        
}

export class UserDetails {
    requestIdentifier?: string;
    transactionDate?: string;
    success?: boolean;
    userList?: User[];
    errors?: Error[] = [];
}

export class Users {
    userId?: number;
    userName?: string;
    status?: string;
    updateBy?: string;
    facilities?: UserFacilities[] = [];        
}

export class UserFacilities {
    custID?: number;
    buId?: number;
    fcyID?: number;
    status?: string;        
}

export class TempUser {
    id?: number;
    loginId?: string;
    firstName?: string;
    lastName?: string;
    middleName?: string;
    userName?: string; // For internal user
    approvalStatus?: string;
    okTempUserId?: string;
    uploadStatus?: string;
}

export class UserRoles {
    id: number;
    usrId: number;
    rolId: number;
}


export class UserCustomers {
    id: number;
    custCode: string;
    custName: string;
    custId: number;
    custRole: Roles[];
    createdDate: string;
    createdBy: string;
    updatedDate: string;
    updatedBy: string;
    userFacilityBusinessUnits?: UserFacilityBusinessUnits[] = [];
}

export class UserFacilityBusinessUnits {
    id?: number;
    businessUnitId?: number;
    businessUnitCode?: string;
    businessUnitName?: string;
    facilityId?: number;
    facilityName?: string;
    uniqueIdentifierId?: string;
    uniqueIdentifierName?: string;
    createdDate: string;
    createdBy: string;
    updatedDate: string;
    updatedBy: string;
    lastLoginTime?: string;
    status?: string;
}

export class MultiSelectDropDown {
    uniqueIdentifierId?: string;
    uniqueIdentifierName?: string;
}

export class Error {
    code: string;
    description: string;
}

export class FscExternalUserResponse {
    requestIdentifier?: string;
    transactionDate?: string;
    success?: boolean;
    user?: User;
    errors?: Error[] = [];
}

export class FscTeamMemberResponse {
    requestIdentifier: string;
    transactionDate: string;
    success: boolean;
    errors: Error[] = [];
    roles: Roles[] = [];
    pendingTeamMembers?: User[] = [];
    approvedTeamMembers?: User[] = [];
    deActivatedTeamMembers?: User[] = [];
    rejectedTeamMembers?: User[] = [];
    paging: Paging;
    userList: any;
  userName: any;
}

export class UserStatusResponse {
    requestIdentifier?: string;
    transactionDate?: string;
    success?: boolean;
    errors?: Error[] = [];
}

export class Paging {
    last: boolean;
    first: boolean;
    totalPages: number;
    totalElements: number;
    size: number;
    numberOfElements: number;
}

/* FCL Response Object Start */

export class AccessTokenResponse {
    access_token: string;
    token_type: string;
    expires_in: string;
    scope: string;
}



export class FCLResponse {
    transactionId: string;
    output: Output;
}

export class Output {
    userProfile: UserProfile;
    loginCookieOutputVO: LoginCookieOutputVO;
}

export class UserProfile {
    registeredContactAndAddress: RegisteredContactAndAddress;
    isManaged: boolean;
    customer: Customer;
    defaultAccount: DefaultAccount;
    siteWideProfile: SiteWideProfile;
    expandedAccounts: ExpandedAccounts[] = [];
    loginInformation :LoginInformation;
}

export class LoginInformation{
    userId :string;
}

export class RegisteredContactAndAddress {
    contact: Contact;
}

export class SiteWideProfile {
    companyAdmin: boolean;
    departmentAdmin: boolean;
}

export class Contact {
    personName: PersonName;
    companyName: string;
    phoneNumber: string;
    emailAddress: string;
    address: Address;
}

export class PersonName {
    firstName: string;
    middleName: string;
    lastName: string;
}

export class DefaultAccount {
    value: string;
    key: string;
}

export class Customer {
    cashOnly: false;
    creditCardUpdateBlocked: boolean;
    ukdomesticAllowed: boolean;
}

export class Address {
    streetLines: string[] = [];
    city: string;
    stateOrProvinceCode: string;
    postalCode: string;
    countryCode: string;
    residential: boolean;
}

export class LoginCookieOutputVO {
    fclCookie: string;
    nameCookie: string;
    contactNameCookie: string;
    uuidCookie: string;
}

export class ExpandedAccounts {
    account: Account;
}

export class Account {
    accountNumber: AccountNumber;
    accountNickname: string;
    accountDisplayName: string;
}

export class AccountNumber {
    value: string;
    key: string;
}

/* FCL Response Object End */

export class RFQRAuthRequest {
    authToken?: string;   
    fscUser?: string; 
    contentType?: string; 
    appId?: string; 
    appName?: string; 
    uuId?: string; 
    userId?: string; 
    userName?: string; 
    loggedInUser?: string; 
    environment?: string; 
    custId?: string; 
    buId?: string; 
    businessUnitCode?: string;
    buName?: string; 
    facilityId?: string; 
    facilityCode?: string;
    facilityName?: string; 
    custName?: string; 
    customerCode?:string;
    module?: string; 
    tracePath?: string; 
    origin?: string; 
    language?: string; 
    oktaJwtToken?: string; 
    refreshToken?: string;
    oktaTempJwtToken?: string; 
    apiGatewayClientId?: string; 
    apiGatewayGrantType?: string; 
    apiGatewayScope?: string; 
    apiGatewaySecret?: string; 
    apiGatewayURL?: string;      
}

export class AccessToken {
    accessToken?: string; 
    expiresAt?: string; 
    tokenType?: string; 
    scopes?: []; 
    authorizeUrl?: string; 
    userinfoUrl?: string; 
}

export class IdToken {
    idToken?: string; 
}

export class RefreshToken {
    refreshToken?: string;

}

export class RFAccessToken {
    accessToken: AccessToken;
    idToken: IdToken;
    refreshToken: RefreshToken;
}

export class AuthURLResponse {
    authURL?: string;  
    empIdEncoded?: string;  
}
